/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('click', function(event) {
  var target = event.target.closest('.nudge-add-btn');
  if (!target) return;
  
  event.preventDefault();
  
  var variantId = target.getAttribute('data-variant-id');
  if (!variantId) return;

  target.classList.add('is-loading');
  target.disabled = true;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(function(response) {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  })
  .then(function(data) {
    target.classList.remove('is-loading');
    target.disabled = false;
    // Notify the theme to refresh the cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  })
  .catch(function(error) {
    console.error('Error adding nudge product:', error);
    target.classList.remove('is-loading');
    target.disabled = false;
    alert('There was an issue adding the product to your cart.');
  });
});

// Listen for Globo Product Options AJAX success event to refresh the theme's mini-cart
document.addEventListener('GloboOptionsAddToCartSuccess', function() {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
});

// Fix for cart upsell nudge modal inside the mini-cart drawer.
// Moves the modal out of the mini-cart bounds into the body so it isn't clipped by overflow:hidden.
document.addEventListener('click', function(event) {
  var openModalBtn = event.target.closest('[data-action="open-modal"]');
  if (openModalBtn) {
    var modalId = openModalBtn.getAttribute('aria-controls');
    if (modalId) {
      var modal = document.getElementById(modalId);
      if (modal && modal.classList.contains('modal--nudge') && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    }
  }
}, true); // Use capture phase to move the node before the theme's native handler attempts to open it

// Handle manual close for nudge modal since moving it to the body breaks theme queue
document.addEventListener('click', function(event) {
  var nudgeModal = event.target.closest('.modal--nudge');
  if (nudgeModal) {
    if (event.target.closest('[data-action="close-modal"]')) {
      nudgeModal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-locked');
      nudgeModal.dispatchEvent(new CustomEvent('modal:closed'));
    }
  }
});
